const $ = window.jQuery;

let s = {
	body : $('body'),
	push : $('.js-push'),

	pushMenuSwitch : 1216,

	// menuToggle         : $('.js-menu__toggle'),
	menuToggleSelector : '.js-menu__toggle',

	// menuClose         : $('.js-menu__close'),
	menuCloseSelector : '.js-menu__close',
};

function init() {
	events();
}

function events() {

	$(window).on('load resize', function() {

		if (window.innerWidth < s.pushMenuSwitch && s.push.hasClass('push--active')) {
			s.body.addClass('no-scroll');
		} else {
			s.body.removeClass('no-scroll');
		}
	});

	s.body.on('click', s.menuToggleSelector, function(event) {
    event.preventDefault();

		s.body.toggleClass('no-scroll');
		s.push.toggleClass('push--active');
		s.push.find('.push__level--top')
			.addClass('push__level--active')
			.addClass('push__level--current');

	}).on('click', s.menuCloseSelector, function(event) {
    event.preventDefault();

		s.push.find('.push__level--top')
			.addClass('push__level--active')
			.addClass('push__level--current');

		setTimeout(function() {

			// close any open accordions
			$('li.menu-item-has-children').removeClass('dropdown-open');
			$('.menu__list .menu__list').hide();

			/** reset scroll */
			s.push
				// .find('.push__level')
				// .scrollTop(0);
				.find('.push__level-inner')
				.scrollTop(0);

			/** reset active */
			s.push
				.find('.push__level--active')
				.removeClass('push__level--active');
		}, 400); // transition
	});

	// accordion action
	// Get all menu items with children (li's with .menu-item-has-children class)
    const menuItemsWithChildren = document.querySelectorAll('.o-mobile-menu .menu-item-has-children > a');

    // Loop through each menu item with children
    menuItemsWithChildren.forEach(function(menuItem) {
        let hasClicked = false;  // Flag to track if the user clicked the link

        menuItem.addEventListener('click', function(event) {
            const parentLi = this.parentElement;  // Get the parent <li>
            const menuList = parentLi.querySelector('.menu__list');  // Get the associated <ul>

            // Check if the click happened on the <svg> inside the <a> element
            if (event.target.closest('svg')) {
                // If the click was on the <svg>, prevent the default link behavior
                event.preventDefault();
                
                // Toggle the visibility of the .menu__list
                menuList.style.display = (menuList.style.display === 'block') ? 'none' : 'block';
                
                // Add/remove the 'dropdown-open' class to the parent <li>
                parentLi.classList.toggle('dropdown-open');
                
                // Don't update the hasClicked flag to allow for proper link behavior on subsequent clicks
                return;
            }

            // If the click was not on the <svg> (i.e., the <a> tag itself was clicked)
            if (!hasClicked) {
                // First click: Prevent the default link behavior
                event.preventDefault();

                // Toggle the visibility of the .menu__list
				if (menuList){
					menuList.style.display = (menuList.style.display === 'block') ? 'none' : 'block';
				}
                

                // Add the 'dropdown-open' class to the parent <li>
                parentLi.classList.toggle('dropdown-open');

                // Set the flag to true, so the user can visit the link on the second click
                hasClicked = true;
            } else {
                // Second click: Allow the link to be visited
                hasClicked = false;  // Reset the flag to allow visiting the link
            }
        });
    });
}

export {init as default};
